import React, { useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import { Legend } from '../Common/Legend';
import { resultDataSetProp } from './utils';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2, 0.5, 0, 0.5)
  }
}));

type TeamProductivityLegendProp = {
  data: resultDataSetProp[][] | undefined;
};

const TeamProductivityLegend: React.FC<TeamProductivityLegendProp> = ({
  data
}: TeamProductivityLegendProp) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const hoursLegend = useMemo(() => {
    const legends = data!.map((_data, index) => {
      return (
        <Legend
          key={index}
          label={formatMessage({
            id: `insights.teamProductivity.hours.${_data[0].id}`
          })}
          color={_data[0].color}
          labelColor={_data[0].color}
          borderColor={_data[0].color}
          borderStyle="soild"
        />
      );
    });
    return legends;
  }, [data, formatMessage]);

  const [firstLegend, secondLegend, thirdLegend, fourthLegend] = hoursLegend;

  return (
    <Grid
      className={classes.container}
      data-testid={'team-productivity-legend-container'}
    >
      <div className={classes.row}>
        <div className={classes.column}>
          {firstLegend}
          {thirdLegend}
        </div>
        <div className={classes.column}>
          {secondLegend}
          {fourthLegend}
        </div>
      </div>
    </Grid>
  );
};
export default React.memo(TeamProductivityLegend);
